import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      component: Home,
      meta: {
        contest: 'lievitamente'
      },
      children: [
        {
          path: 'partecipa',
          component: Home,
          props: true,
          meta: {
            showModal: true,
            contest: 'lievitamente'
          }
        },
        {
          path: 'masterdelcornicione',
          component: Home,
          props: true,
          meta: {
            showModal: true,
            promo: true,
            contest: 'masterdelcornicione'
          }
        }
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js